module.exports = __webpack_public_path__ + "static/img/cadillac_4.b2e2ee8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ios-bluetooth/cadillac_4.png
// module id = gdYY
// module chunks = 215